import { render, staticRenderFns } from "./Group.vue?vue&type=template&id=6c59edaf&scoped=true&"
import script from "./Group.vue?vue&type=script&lang=js&"
export * from "./Group.vue?vue&type=script&lang=js&"
import style0 from "./Group.vue?vue&type=style&index=0&id=6c59edaf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c59edaf",
  null
  
)

export default component.exports